import React from 'react';
// 1. 버튼들을 정렬하기 위해 Space를 import 합니다.
import { Input, Button, Alert, Space } from 'antd';
import JsonViewer from './JsonViewer';
import useJsonParser from '../../../pages/json/useJsonParser';

const { TextArea } = Input;

const JsonParserWithViewer = () => {
    const {
        input,
        setInput,
        data,
        error,
        cursorInfo,
        textareaRef,
        handleParse,
        handleCursorChange,
        // 2. 훅에서 handleClear 함수를 가져옵니다.
        handleClear,
    } = useJsonParser();

    return (
        <div style={{ maxWidth: 800 }}>
            <TextArea
                ref={textareaRef}
                rows={8}
                value={input}
                onChange={(e) => setInput(e.target.value)}
                onSelect={handleCursorChange}
                onKeyUp={handleCursorChange}
                onClick={handleCursorChange}
                placeholder="JSON을 입력하세요"
            />
            {/* 3. 버튼들을 Space 컴포넌트로 감싸 깔끔하게 배치합니다. */}
            <Space style={{ marginTop: 10 }}>
                <Button onClick={handleParse} type="primary">
                    파싱
                </Button>
                {/* 4. '새로 입력' 버튼을 추가하고 onClick에 handleClear를 연결합니다. */}
                <Button onClick={handleClear}>
                    새로 입력
                </Button>
            </Space>

            <div style={{ marginTop: 8, fontSize: 12, color: '#888' }}>
                현재 커서 위치: {cursorInfo.line}행 {cursorInfo.column}열
            </div>

            {error && (
                <Alert
                    type="error"
                    message="JSON 파싱 오류"
                    description={error}
                    showIcon
                    style={{ marginTop: 16 }}
                />
            )}

            {data && (
                <div style={{ marginTop: 16 }}>
                    <JsonViewer data={data} />
                </div>
            )}
        </div>
    );
};

export default JsonParserWithViewer;